var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{staticClass:"radio-group",attrs:{"value":_vm.value},on:{"input":_vm.updateValue}},_vm._l((_vm.options),function(option){return _c('el-radio',{key:option.value,attrs:{"label":option.value}},[_vm._v(" "+_vm._s(option.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }